import { useI18nContext } from './I18nProvider';

/**
 * Hook for accessing translations
 *
 * @example
 * ```tsx
 * const { t } = useTranslation();
 *
 * // Simple usage
 * <h1>{t('motr::Dashboard')}</h1>
 *
 * // With parameters
 * <p>{t('motr::WelcomeMessage', { name: user.name })}</p>
 *
 * // Using :: prefix (assumes motr resource)
 * <button>{t('::Save')}</button>
 * ```
 */
export const useTranslation = () => {
  const {
    t,
    currentCulture,
    availableLanguages,
    setLanguage,
    isLoading,
    isRTL,
  } = useI18nContext();

  return {
    /**
     * Translate a key with optional parameter interpolation
     * @param key - Translation key in format 'resource::key' or '::key'
     * @param params - Optional parameters for interpolation
     */
    t,
    /**
     * Current culture name (e.g., 'en', 'es')
     */
    currentCulture,
    /**
     * List of available languages
     */
    availableLanguages,
    /**
     * Change the current language
     */
    setLanguage,
    /**
     * Whether translations are loading
     */
    isLoading,
    /**
     * Whether current language is RTL
     */
    isRTL,
  };
};

export default useTranslation;
